import React, { useEffect, useState } from 'react';
import axios from 'axios';
import firebase from "firebase/compat/app";
import { firebaseConfig } from './firebase';

import {
  collection,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
} from "firebase/firestore";
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import { toast } from "react-toastify";
import { db } from "../firebase.js";
import SmartToyIcon from '@mui/icons-material/SmartToy'; // AI icon
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import BedIcon from '@mui/icons-material/Bed';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BathtubIcon from '@mui/icons-material/Bathtub';
import GrassIcon from '@mui/icons-material/Grass';
import ConstructionIcon from '@mui/icons-material/Construction';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import VillaIcon from '@mui/icons-material/Villa';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import FoundationIcon from '@mui/icons-material/Foundation';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import EmailIcon from '@mui/icons-material/Email';
import LocalFireDepartmentIcon from '@mui/icons-material/LocalFireDepartment';
import HouseSidingIcon from '@mui/icons-material/HouseSiding';
import FenceIcon from '@mui/icons-material/Fence';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import AddIcon from '@mui/icons-material/Add';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import BusinessIcon from '@mui/icons-material/Business';
import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import GavelIcon from '@mui/icons-material/Gavel';
import PhoneIcon from '@mui/icons-material/Phone';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CottageIcon from '@mui/icons-material/Cottage';
import PaidIcon from '@mui/icons-material/Paid';
import ListingItem from "../components/ListingItem.jsx";
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import NewPatientModal from './NewPatientModal.jsx.jsx';
import { Button } from 'react-bootstrap';
import LockIcon from '@mui/icons-material/Lock';
import SpeedIcon from '@mui/icons-material/Speed';
import SupportIcon from '@mui/icons-material/Support';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import HolidayVillageIcon from '@mui/icons-material/HolidayVillage';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import GridViewRoundedIcon from "@mui/icons-material/GridViewRounded";
import ReceiptRoundedIcon from "@mui/icons-material/ReceiptRounded";
import BarChartRoundedIcon from "@mui/icons-material/BarChartRounded";
import TimelineRoundedIcon from "@mui/icons-material/TimelineRounded";
import BubbleChartRoundedIcon from "@mui/icons-material/BubbleChartRounded";
import WalletRoundedIcon from "@mui/icons-material/WalletRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";
import MonetizationOnRoundedIcon from "@mui/icons-material/MonetizationOnRounded";
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ShieldRoundedIcon from "@mui/icons-material/ShieldRounded";
import HouseIcon from '@mui/icons-material/House';
import GppGoodIcon from '@mui/icons-material/GppGood';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import NotificationsRoundedIcon from "@mui/icons-material/NotificationsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PieChartIcon from '@mui/icons-material/PieChart';
import SearchIcon from '@mui/icons-material/Search';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddHomeIcon from '@mui/icons-material/AddHome';
import SchoolIcon from '@mui/icons-material/School';
import GroupIcon from '@mui/icons-material/Group';
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { getAuth } from "firebase/auth";
import Contact from "../components/Contact";
import { doSignOut } from "./auth.js";
import { useAuth } from "./authContext";
import GaugeComponent from 'react-gauge-component';
import DirectionsCarFilledIcon from '@mui/icons-material/DirectionsCarFilled';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { CardMedia } from "@mui/material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import PeopleIcon from '@mui/icons-material/People';
import { Chip } from "@mui/material";
import StateModal from "./StateModal.jsx";
import TenantModal from "./TenantModal.jsx";
import UpsellModal from './UpsellModal.jsx';
import ProfileComponent from './ProfileComponent.jsx';
import ZillowClonePage from './ZillowClonePage.jsx';
import { CalendarMonth, ComputerSharp, CreditCard } from '@mui/icons-material';
import { FaWrench } from 'react-icons/fa';

// Fix leaflet default icon issues
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl:
    'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

// =====================================================================
// New ZillowClonePage component with a two-panel layout (map & listings)
// =====================================================================

// =====================================================================
// Main DealExplorer2 Component (your existing code with sidebar)
// =====================================================================
firebase.initializeApp(firebaseConfig);

const DealExplorer2 = () => {
  const { currentUser } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    addressLine1: '',
    addressLine2: ''
  });
  const [resultData, setResultData] = useState(null);
  const [error, setError] = useState(null);
  const [user, setUser] = useState(null);
  const [showWelcome, setShowWelcome] = useState(true);

  console.log(resultData);

  const DealExplorerUpsell = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Deal Explorer</button>
        <UpsellModal open={open} onClose={handleClose} />
      </>
    );
  };

  const OpenModalButton = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Housing Authority</button>
        <StateModal open={open} onClose={handleClose} />
      </>
    );
  };

  const OpenModalButton2 = () => {
    const [open, setOpen] = React.useState(false);
  
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
  
    return (
      <>
        <button onClick={handleOpen}>Tenant Lookup</button>
        <TenantModal open={open} onClose={handleClose} />
      </>
    );
  };


  
  
  // Shuffle function using Fisher-Yates algorithm
  const shuffleArray = (array) => {
    let shuffledArray = [...array];
    for (let i = shuffledArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
    }
    return shuffledArray;
  };
  
  
  useEffect(() => {
    setTimeout(() => {
      firebase
        .firestore()
        .collection("users")
        .doc(currentUser.uid)
        .get()
        .then((snapshot) => {
          if (snapshot.exists) {
            setUser(snapshot.data());
            console.log("USERID", currentUser.uid);
            console.log("USER", user);
          } else {
            console.log("does not exist");
          }
        });
    }, 1000);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setResultData(null);

    try {
      const response = await axios.post(
        'https://devapi.endato.com/Contact/Enrich',
        {
          FirstName: formData.firstName,
          LastName: formData.lastName,
          Address: {
            addressLine1: formData.addressLine1,
            addressLine2: formData.addressLine2,
          },
        },
        {
          headers: {
            'galaxy-ap-name': '9c98fe55f8014288bfe14ea5918a433e',
            'galaxy-ap-password': '39b84f31734c4a21be261904d59cddc5',
            'galaxy-search-type': 'DevAPIContactEnrich',
          },
        }
      );
      setResultData(response.data);
    } catch (err) {
      setError('An error occurred while fetching data.');
    }
  };

  if (!user) {
    return <div></div>;
  } else
    return (
        <>
         {showWelcome && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <button
              style={styles.modalClose}
              onClick={() => setShowWelcome(false)}
            >
              ×
            </button>

            <Card
              sx={{
                width: 900,
                backgroundColor: 'white',
                marginBottom: '20px',
                paddingBottom: '20px',
                borderRadius: '20px',
                boxShadow: 'none',   // remove shadow
                border: 'none',      // remove any border
              }}
            >
              <img
                src="https://i.ibb.co/Y4gGzdRs/1.jpg"
                width={900}
                alt="Welcome"
              />

              <div style={styles.cardContent}>
                <h1 style={styles.cardTitle}>
                  Your Real Estate Journey Begins Today
                </h1>
                <p style={styles.cardText}>
                  We are so excited to have you on board! Before you dive in,
                  here's a brief rundown on the features of this program.
                </p>

                <div style={styles.features}>
                  <div style={styles.feature}>
                    <h2 style={styles.featureTitle}>FMR Explorer</h2>
                    <p style={styles.featureDescription}>
                      The FMR Explorer is an innovative tool that allows users
                      to explore Fair Market Rent (FMR) data across various
                      counties with an interactive map. By selecting a county,
                      users can instantly access detailed information on the
                      fair market rents specific to that area. We pull over
                      1.4 million data points to ensure the most accurate and
                      up-to-date county-level insights, including key
                      statistics such as population, average mortgage costs,
                      and the FMR-to-mortgage ratio. With this comprehensive
                      data, users can make more informed decisions when
                      evaluating rental opportunities and investment potential
                      in different regions.
                    </p>
                  </div>

                  <div style={styles.feature}>
                    <h2 style={styles.featureTitle}>Market Research</h2>
                    <p style={styles.featureDescription}>
                      The Market Research feature is a powerful feature that
                      allows users to gain in-depth insights on any property in
                      the United States by simply entering an address. Our vast
                      database of over 300 million data points provides access
                      to exclusive property details that you won’t find
                      anywhere else. This includes ownership contact
                      information, tax history, lot size, sale history, and
                      more. But we don’t stop at just the property data—our tool
                      also offers a comprehensive crime report for the area,
                      giving you a clear picture of the neighborhood.
                      Additionally, we provide valuable insights into the
                      likelihood of natural disasters in the region using our
                      National Disaster Index, as well as detailed demographics
                      and climate reports. With Market Explorer, users can make
                      well-informed decisions based on a wide range of factors
                      that influence property value and safety.
                    </p>
                  </div>

                  <div style={styles.feature}>
                    <h2 style={styles.featureTitle}>Deal Calculator</h2>
                    <p style={styles.featureDescription}>
                      The Deal Calculator is an incredibly comprehensive tool
                      designed to simplify property investment analysis.
                      Simply input the key details about a property you’re
                      interested in, such as the price, down payment, interest
                      rate, and loan term, and let the calculator do the rest.
                      It provides you with a clear breakdown of your expected
                      monthly expenses, including insurance and property taxes,
                      while also calculating your potential rental income or
                      return on investment. The calculator estimates both your
                      monthly and yearly earnings, helping you gauge the
                      financial performance of your investment. With the Deal
                      Calculator, you can make confident decisions by
                      understanding the true costs and profitability of any
                      property.
                    </p>
                  </div>

                  <div style={styles.feature}>
                    <h2 style={styles.featureTitle}>Deal Explorer</h2>
                    <p style={styles.featureDescription}>
                      The Deal Explorer is a game-changing tool designed to
                      help you find the perfect Section 8 investment property.
                      With access to over 140 million property records, it’s
                      like Zillow, but tailored specifically for Section 8
                      housing. Once you find a property in a market that
                      interests you, you can instantly access our Deal Explorer
                      Calculator, which automatically populates with all the
                      property details. This means you can quickly decide on
                      your down payment and calculate your monthly cash flow in
                      seconds. With Deal Explorer, you gain instant, accurate
                      insights into any available property for sale, making it
                      easier than ever to evaluate potential Section 8
                      investments and take action.
                    </p>
                  </div>
                </div>
              </div>
            </Card>
            <div style={styles.goButtonContainer}>
              <button
                style={styles.goButton}
                onClick={() => setShowWelcome(false)}
              >
                Let’s Go!
              </button>
            </div>
          </div>
        </div>
      )}
      <div  style={{ backgroundColor: '#f1f4f9' }}>
      <div style={{ display: 'flex', minHeight: '100vh', alignItems: 'stretch' }}>
  <Sidebar
    style={{
      backgroundColor: '#000222',
      flex: '0 0 250px', // Fixed width for the sidebar
    }}
  >
            <Menu style={{ backgroundColor: '#000222' }}>
              <MenuItem>
                <div style={{ marginLeft: -43, backgroundColor: 'white' }}>
                  <img
                    src="https://i.ibb.co/s2dBvDt/elevate.png"
                    alt="logo"
                    className="ml-4 mt-12 -p-4 "
                    width={300}
                  ></img>
                </div>
              </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white', marginTop: '50px' }} onClick={() => window.location = 'fmrexplorer'} icon={<LocationOnIcon />}> FMR Explorer </MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'propertylookup'} icon={<SearchIcon />}>Market Research</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealcalculator'} icon={<CalculateIcon />}>Deal Calculator</MenuItem>
              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'dealexplorer'} icon={<AddHomeIcon />}>Deal Explorer</MenuItem>

              
<MenuItem
  style={{
    backgroundColor: '#000222',
    color: 'white',
    fontSize: 18,
    display: 'flex',
    alignItems: 'center',
  }}
  onClick={() => window.location = 'dealexplorerai'}
>
  <span style={{ display: 'flex', alignItems: 'center' }}>
    <AutoAwesomeIcon fontSize="small" style={{ marginRight:18}}/>
    Deal Explorer Ai
    <Chip
      label="beta"
      size="small"
      style={{
        backgroundColor: 'white',
        color: '#000222',
        fontSize: 10,
        fontWeight: 600,
        height: 18,
        borderRadius: 9999,
        marginLeft:4
      }}
    />
  </span>
</MenuItem>   

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'skiptrace'} icon={<VisibilityIcon />}>Skip Trace</MenuItem>

<MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.location = 'rentcast'} icon={<SpeedIcon />}>Rent Reveal</MenuItem>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} icon={<HouseIcon />}> <OpenModalButton /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<EmojiPeopleIcon />}> <OpenModalButton2 /> </MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<SupportIcon />} onClick={() => window.open('https://elevatecoachingrei.steadilypartner.com/', "_blank")}> Landlord Insurance </MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color:'white'}} onClick ={()=> window.location = 'community'} icon={<PeopleIcon />}>Community Hub</MenuItem>
                <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<ComputerSharp />} onClick={() => window.open('https://section8guys.com/training', "_blank")}> Next Webinar </MenuItem>

              <SubMenu label="Book a Session" style={{ backgroundColor: '#000222', color: 'white' }} icon={<CalendarMonth />}>
               
                <MenuItem icon={<PeopleIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/googlemeet?back=1&month=2025-01', "_blank")}>
                  1-on-1s
                </MenuItem>
                <MenuItem icon={<BusinessIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/inoffice?back=1&month=2025-01', "_blank")}>
                  Day in the Office
                </MenuItem>
                <MenuItem icon={<DirectionsCarFilledIcon />} style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://calendly.com/elevaterei/ridealong?back=1&month=2025-01', "_blank")}>
                  Ride Along
                </MenuItem>
              </SubMenu>
             
    
              <SubMenu label="Investor Solutions" style={{ backgroundColor: '#000222', color: 'white' }} icon={<BusinessIcon />}>
                              <MenuItem icon={<LockIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Asset Protection </MenuItem>
                                              <MenuItem icon={<AttachMoneyIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Business Funding </MenuItem>
                <MenuItem icon={<CreditScoreIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Credit Builder </MenuItem>
                <MenuItem icon={<FaWrench />} onClick={() => window.open('https://elevatecoachingrei.thecreditbrothers.com/learn-more?entry_source=elevatecoachingrei', "_blank")}> Credit Repair </MenuItem>
                <MenuItem icon={<AddIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}>Entity Formation </MenuItem>
                <MenuItem icon={<RequestQuoteIcon />} onClick={() => window.open('https://www.primecorporateservices.com/entity-formation-wg/?utm_source=ElevateHoldingsLLC&utm_medium=LP&utm_campaign=NA', "_blank")}> Taxes </MenuItem>
              </SubMenu>
                <MenuItem style={{ color: 'white', backgroundColor: '#000222' }} onClick={() => window.open('https://lendsimpli.com/elevate/', "_blank")} icon={<CurrencyExchangeIcon />}> Property Loans </MenuItem>
                              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} onClick={() => window.open('https://www.skool.com/elevate-wsection-8-8185', "_blank")} icon={<SchoolIcon />}>Skool Community</MenuItem>

              <MenuItem style={{ backgroundColor: '#000222', color: 'white' }} icon={<LogoutRoundedIcon />} onClick={() => doSignOut({ callbackUrl: '/', redirect: true })}> Logout </MenuItem>
              <div style={{ ...styles.container1, backgroundColor: '#000222' }}>
                <ProfileComponent user={user} />
              </div>
            </Menu>
          </Sidebar>
          <>
            {/* Render the ZillowClonePage with our two-panel map and listings */}
<div
  style={{
    flex: 1,
    height: '100vh',       // ← hard cap to viewport
    minHeight: '100vh',
    overflow: 'hidden',    // ← prevent scroll pushing children
    position: 'relative',  // ← allows children to absolutely-position
  }}
>  <ZillowClonePage  />
</div>
          </>
        </div>
      </div>
      </>
    );
};

export default DealExplorer2;

// =====================================================================
// Additional inline styles from your existing code
// =====================================================================
const styles = {
    container: {
      margin: '20px auto',
      maxWidth: '600px',
      fontFamily: 'Arial, sans-serif',
    },
    list: {
      listStyleType: 'none',
      padding: 0,
      margin: 0,
      width: '100%',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    listItem: {
      padding: '12px 16px',
      cursor: 'pointer',
      borderBottom: '1px solid #ddd',
      backgroundColor: '#fff',
      width: '100%',
      transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    },
    listItemHover: {
      backgroundColor: '#f7f7f7',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    },
    centerScreen: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#fff',
      minHeight: '100vh',
    },
    container1: {
      display: 'flex',
      justifyContent: 'center',
      backgroundColor: '#fff',
      alignItems: 'center',
      height: '100%',
      marginTop: '0px',
    },
    profile: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      backgroundColor: '#000222',
      padding: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    },
    profileAvatar: {
      width: '52px',
      height: '52px',
      borderRadius: '50%',
      marginRight: '21px',
    },
    profileName: {
      fontSize: '17px',
      fontWeight: 'bold',
      color: 'white',
      margin: 0,
    },
    profileHandle: {
      fontSize: '11px',
      color: 'white',
      margin: 0,
    },
    cardContainer: {
      width: '450px',
      margin: '50px auto',
      borderRadius: '15px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      backgroundColor: '#fff',
      textAlign: 'center',
      fontFamily: 'Arial, sans-serif',
    },
    cardImage: {
      width: '100%',
      height: 'auto',
    },
    cardContent: {
      padding: '20px',
    },
    cardTitle: {
      fontSize: '28px',
      fontWeight: 'bold',
      marginBottom: '15px',
      color: '#333',
      textAlign: 'center',
    },
    cardText: {
      fontSize: '16px',
      color: '#555',
      lineHeight: '1.6',
      marginBottom: '20px',
      textAlign: 'center',
    },
    features: {
      marginTop: '20px',
      textAlign: 'left',
    },
    feature: {
      marginBottom: '20px',
    },
    featureTitle: {
      fontSize: '20px',
      color: '#007bff',
      marginBottom: '8px',
      fontWeight: '600',
    },
    featureDescription: {
      fontSize: '16px',
      color: '#555',
      lineHeight: '1.6',
      margin: '0',
    },
  
    // ——— Modal Styles ———
    modalOverlay: {
      position: 'fixed',
      top: 0, left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modalContent: {
      position: 'relative',
      background: '#fff',
      borderRadius: 20,
      width: 900,
      maxWidth: '90%',
      maxHeight: '80vh',
      overflowY: 'auto',
      paddingBottom: '20px',
      marginTop: '80px',
    },
    modalClose: {
      position: 'absolute',
      top: 8,
      right: 8,
      border: 'none',
      background: 'transparent',
      fontSize: '1.5rem',
      cursor: 'pointer',
    },
    modalOverlay: {
        position: 'fixed',
        top: 0, left: 0,
        width: '100%', height: '100%',
        background: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      },
      modalContent: {
        position: 'relative',
        background: '#fff',
        borderRadius: 20,
        width: 900,
        maxWidth: '90%',
        maxHeight: '80vh',
        overflowY: 'auto',
        paddingBottom: '20px',
        marginTop: '80px',
      },
      modalClose: {
        position: 'absolute',
        top: 8,
        right: 8,
        border: 'none',
        background: 'transparent',
        fontSize: '1.5rem',
        cursor: 'pointer',
      },
    
      // this is the style for the Let's Go! button
      goButtonContainer: {
        textAlign: 'center',
        margin: '20px 0',
      },
      goButton: {
        padding: '10px 20px',
        fontSize: '16px',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: '#007bff',
        color: '#fff',
        cursor: 'pointer',
      },
  };
  
